module.exports = __webpack_public_path__ + "static/media/vision_nocolor.5de5aa2d.svg";